import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleWeb } from '../material/material.module';
import { WebThemeComponent } from './web-theme.component';



@NgModule({
  declarations: [
    WebThemeComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    FormsModule,  
    ReactiveFormsModule,
  ],
  exports: [
    WebThemeComponent
  ]
})
export class WebThemeModule { }
